import { LikesConfig, Resource } from '@yandex-int/k-common';
import { getLikesConfig, getSubjectConfig } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import { getNumber as getClassNumber } from 'common.components/classes/selectors';
import { getSubjectFromProps } from 'utils/selectors/selectors';

import { LikesStoreState, ReduxLikesStoreState } from './typings';

const storeStateSelector = (reduxStore: ReduxLikesStoreState): LikesStoreState => reduxStore.likes;
export const getClessonLikesCount = createSelector([storeStateSelector], (state) => {
    return state?.clessonLikes;
});

export const getClessonReactionsLoadingStatuses = createSelector(
    [storeStateSelector],
    (state) => state.resourceLoadingStatuses
);

export const getClessonLikes = createSelector([storeStateSelector], (state) => state.clessonLikes);

export const getClessonLikesResources = createSelector(
    [storeStateSelector],
    (state): Record<number, Resource> => state.resources
);

export const getLikesMeta = createSelector(
    [getClessonLikesResources, getLikesConfig],
    (resources, config: LikesConfig): { slug: string; url: string }[] => {
        const orderKeys = config.order.reduce(
            (result, key, index) => {
                result[key] = index;
                return result;
            },
            {} as Record<string, number>
        );

        return config.items
            .reduce(
                (items, item) => {
                    const resource = resources[item.resource_id];
                    if (resource && resource.file) {
                        items.push({
                            slug: item.slug,
                            url: resource.file,
                        });
                    }
                    return items;
                },
                [] as { slug: string; url: string }[]
            )
            .sort((a, b) => orderKeys[a.slug] - orderKeys[b.slug] || 0);
    }
);

export const getShouldShowLikeReactions = createSelector(
    [getClassNumber, getSubjectConfig, getSubjectFromProps],
    (currentGrade, subjectConfig, currentSubject) => {
        if (!currentGrade || !subjectConfig) {
            return false;
        }

        const currentSubjectConfig = subjectConfig.list.find(({ subject }) => subject === currentSubject);
        return Boolean(currentSubjectConfig?.grades_with_like_reaction?.includes(currentGrade));
    }
);

export const getClessonTotalLikes = createSelector([getClessonLikes], (state) => {
    return Object.entries(state).reduce(
        (result, lesson) => {
            const clessonId = Number(lesson[0]);
            result[clessonId] = Object.entries(lesson[1]).reduce((sum, item) => sum + item[1], 0);
            return result;
        },
        {} as Record<number, number>
    );
});
